import { render, staticRenderFns } from "./AppThemeToggle.vue?vue&type=template&id=1e4709b4&"
import script from "./AppThemeToggle.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AppThemeToggle.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports